import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { compose, withHandlers, withState, } from 'recompose'

import * as UserSelectors from 'modules/user/selectors'
import config from 'config'

import TouchlessStart from './component'

const mapStateToProps = state => ({
  flow: UserSelectors.getFlow(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('loginUrl', 'setLoginUrl', `${config.START_WEB_URL}/login`),
  withState('keystrokeCounter', 'setKeystrokeCounter', 0),
  withState('interactiveColor', 'setInteractiveColor', false),
  withState('startTimer', 'setStartTimer', new Date()),
  withState('displayChatNumber', 'setDisplayChatNumber', 0),
  withState('initialInterval', 'setInitialInterval', props => setInterval(() => props.setDisplayChatNumber(Math.floor(Math.random() * 8)),2000)),
  withHandlers({
    onValueChange: props => () => {
      props.setInteractiveColor(true)
      clearInterval(props.initialInterval)
      props.setKeystrokeCounter(props.keystrokeCounter + 1)
      if ((props.keystrokeCounter >= 2) && (new Date() - props.startTimer > 1000)) {
        props.setKeystrokeCounter(0)
        props.setDisplayChatNumber(Math.floor(Math.random() * 8))
        props.setStartTimer(new Date())
      }
    },
  })
)(TouchlessStart)



// WEBPACK FOOTER //
// ./src/layouts/TouchlessStart/index.js